import { webappEn } from '../locales/en'
import { LocalizationResources } from '../types'

export const webappLocalizationResources: LocalizationResources = {
  en: {
    translation: webappEn,
  },
}
